import React from "react";
import "./home.css";
import { Link } from "gatsby";
import NavBar from "./components/NavBar.js";
import "./resume.css";
import pdf from "./images/pdf.svg";
import demo from "./images/demo.svg";
import report from "./images/report.svg";
import website from "./images/website.svg";

export default function Resume() {
  return (
    <body>
      <NavBar active="resume" />
      <Link to="https://docs.google.com/document/d/1figgTvLZFSqU8MkfzOC_iNWPW0yvGTJCmQ9Ti6SRQdU/edit?usp=sharing">
        <img title="resume here" src={pdf} className="icon resumeIcon" />
      </Link>
      <div className="resumeBody">
        <h1 className="name">Karen Gao</h1> 787.398.8296 | San Juan, PR 00918 |{" "}
        <a href="mailto:karengao@mit.edu" target="_blank">
          karengao@mit.edu
        </a>{" "}
        |{" "}
        <Link to="https://www.linkedin.com/in/karen-g-b753ab98/">LinkedIn</Link>{" "}
        |{" "}
        <Link to="https://www.youtube.com/watch?v=bYdiokr0fBw&feature=youtu.be">
          Video Portfolio
        </Link>
        <h2>Education</h2>
        Massachusetts Institute of Technology | Cambridge, MA
        <p>Major: Computer Science and Engineering (4.8/5.0 GPA) </p>Expected:
        May 2022
        <h3>Relevant coursework</h3> Software Construction (Java), Design &
        Analysis of Algorithms, Computer System Engineering, Computation
        Structures (Assembly/Bluespec), Interconnected Embedded Systems (C++),
        Artificial Intelligence, Programming in Python, Math for Computer
        Science.
        <h3>Honors and Distinction </h3>
        3rd place MIT Battlecode Programming Competition (2020), Stamps Scholar
        Semifinalist Georgia Tech (2018), Rensselaer Medalist (2017), Gold
        Medalist Math Olympiad of Puerto Rico ( 2014 & 2015), Bronze Medalist
        South American Math Olympiad (2014).
        <h3>Activities</h3>
        WebLab (Web Dev) Competition 2021, Mens et Manus Hands-on Seminar (built
        underwater fish-bot using Arduino)., MIT Entrepreneurship & Leadership
        Pre-Orientation Program (DEAL) 2018
        <p>Languages: Fluent in English, Spanish, and Mandarin.</p>
        <h2>Computer Skills</h2>
        Languages: Python, Java, C++, RISC-V Assembly, Bluespec, React, SQL,
        JavaScript, HTML/CSS, R, Swift, Node.js
        <p>
          Git, specs/testing, Apache Flume, regex, concurrency, HTTP/server, 
          microcontrollers, accelerometer, Xcode, Arduino.
        </p>
        <h2>Projects and Work Experience</h2>
        <h3>
          Software Engineer Intern at Google 
        </h3>
        <h4>Jun - Aug 2021</h4>
        <p>
          Built a streaming pipeline that processes real-time GCP access data to 
          detect anomalies in the system such as newly changed policies blocking a 
          user’s current access to a cloud project using Apache FlumeC++ and 
          defining my own activity protocol buffers to write the pipeline’s 
          resulting aggregated data to a data sink. 
        </p>
        <p>
          Built a batch-mode pipeline that processes sampled access logs to 
          extract information like when’s the last time the user exercised a 
          given permission on a given project successfully or unsuccessfuly. 
        </p>
        <h3>
          Scrapbook: A Social Media Travel Photobook Web App in React and
          Node.js
        </h3>
        <h4>Jan 2020</h4>
        <p>
          Designed the backend and UI for a travel app from scratch in 2 weeks
          that allows users to create posts with captions, photos, and optional
          stamp/background colors within each chapter/trip along with its
          location to be displayed on the map tab so that other users can see
          using react simple map libraries.
        </p>
        <p>
          Implemented the backend user/page/chapter schemas and API calls for
          creating/deleting chapters and pages, updating user bio/profile pic in
          Node.js to the MongoDB database, and storing the uploaded images with
          an image id in the Google Cloud which can be retrieved later with GET
          requests for rendering.{" "}
        </p>
        <p>
          Programmed the frontend for the scrapbook UI/UX (posts, chapters,
          comments, likes), map tooltip with hover feature for displaying
          chapters on the interactive map, profile update, and animated
          homepage.
        </p>
        <Link to="https://tagg-it.herokuapp.com/">
          <img title="website" src={website} className="icon" />
        </Link>{" "}
        <Link to="https://www.youtube.com/watch?v=9F4QZQ422pg&feature=youtu.be">
          <img title="demo" src={demo} className="icon" />
        </Link>
        <h3>Multiplayer Threadsafe Java Swing GUI Crossword Game</h3>
        <h4>Nov - Dec 2020</h4>
        <p>
          Implemented a client and UI for a multiplayer crossword game on the
          server at port 4949 that allows for fill, erase, check, and
          concurrency using live update (watch method/callback functions) on the
          server.
        </p>
        <p>
          Designed a client-server wire protocol in regex grammar, specs for the
          crossword ADT that stores game state, and multi-threaded tests for the
          server to handle concurrent requests like look, erase, get list of
          games, and watch, that returns the current board state along with the
          players in it once there’s been a change.
        </p>
        <Link to="https://www.youtube.com/watch?v=XZ-P0QUQFrc&t=2s">
          <img title="demo" src={demo} className="icon" />
        </Link>
        <h3>
          Quicksort RISC-V ALU Processor Hardware Optimization in
          Bluespec/Assembly
        </h3>
        <h4>Nov - Dec 2020</h4>
        <p>
          Designed and optimized a 4-stage RISC-V processor in Bluespec that can
          handle ALU, branch, jump, and load/store instructions for quicksort
          code in Assembly under 50,000 ns by adding in a memory stage between
          execute and writeback to decrease CPI, along with bypass and annul
          logic from the later stages to decode.{" "}
        </p>
        <p>
          Implemented a pipelined partition module, specialized instruction
          fetch and two way set associative data caches, and a 4-stage pipelined
          8-bit sorter for the base case to further decrease CPI and clock time.
        </p>
        <h3>
          Interconnected Embedded Systems Project: Multiplayer Web Server Party
          Game
        </h3>
        <h4>Apr - May 2020</h4>
        <p>
          Programmed a bluffing multiplayer party game supporting up to six
          players using Arduino/C++ connected to a shared web server where each
          submits bluffs and votes for their favorite bluff on their local ESP32
          using a button-tilt mechanism, LCD Screen, and Gyroscope/IMU.{" "}
        </p>
        <p>
          Coded in SQL/Python to communicate to our website via a database and
          tested it using Git, Postman API, and SSH/SCP server files
          transferring.
        </p>
        <Link to="https://77852924-612b-428c-b57a-87d235a9c84c.filesusr.com/ugd/0dbcab_07aa8631f303433abae0153182564793.pdf">
          <img title="report" src={report} className="icon" />
        </Link>{" "}
        <h3>
          Data Mining & Biostatistics Researcher at Big Data Summer Institute at
          UM-Ann Arbor
        </h3>
        <h4>Jun - Jul 2019</h4>
        <p>
          Used mixed-effects models and machine learning classifications (e.g.
          RF, SVM, NB) to determine whether certain cancer drugs are effective
          in treating their corresponding cell line through observing IC50
          values.
        </p>
        <Link to="https://docs.google.com/presentation/d/1e2IakVaJErtQwHdsxdyh5jNZyT6e75ACx4xJb2Eq8p8/edit?usp=sharing">
          <img title="poster" src={report} className="icon" />
        </Link>
      </div>
    </body>
  );
}
